import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { CBadge } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';

import { LoginService } from '../../../../core/services/login/login.service';
import { Badge, NavItem } from '../../../../core/interfaces';
import NavSeparator from '../../../../core/interfaces/nav-separator';
import { useIdentityStore } from '../../../../core/store';


interface AppSidebarNavProps {
  items: NavItem[];
}

export const AppSidebarNav: FC<AppSidebarNavProps> = ({ items }) => {

  const { identity } = useIdentityStore(state => state);
  // const [identity, setIdentity] = useState(undefined);
  // const [expandedGroup, setExpandedGroup] = useState<string | null>(null);
  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);


  // useEffect(() => {
  //   (async () => {
  //     let id = await LoginService.getIdentityAsync();
  //     setIdentity(id);
  //   })();
  // }, []);

  useEffect(() => {
    // console.log("entraria en dashboard?", identity);
  }, [identity]);


  const location = useLocation();

  const handleGroupClick = (groupToToggle: string) => {
    setExpandedGroups(prevState =>
      prevState.includes(groupToToggle)
        ? prevState.filter(group => group !== groupToToggle)
        : [...prevState, groupToToggle]
    );
  };

  const navItem = (item: NavItem, index: number, identity) => {
    const { component, name, badge, icon, roles, to, ...rest } = item;
    const Component = component;

    if (roles && !roles.includes(identity?.role)) {
      return null;
    }

    const isActive = location.pathname === to;

    return (
      <Component
        key={index}
        name={name}
        icon={icon}
        badge={badge}
        to={to}
        roles={roles}
        className={`${isActive ? 'bg-gray-700 text-white' : 'text-gray-400'} px-4 py-2 hover:bg-gray-800 hover:text-white`}
      />
    );
  };


  const navGroup = (item: NavItem, index: number) => {
    const { component, name, icon, to, roles, items, ...rest } = item;
    const Component = component;

    if (roles && !roles.includes(identity?.role)) {
      return null;
    }

    const isExpanded = expandedGroups.includes(name as string);

    return (
      <div key={index}>
        <div onClick={() => handleGroupClick(name as string)}
        // className={`px-4 py-2 cursor-pointer ${isExpanded ? 'bg-gray-700 text-white' : 'text-gray-400'} hover:bg-gray-800 hover:text-white`}
        >
          <Component name={name} icon={icon} visible={isExpanded} {...rest} />
        </div>
        {isExpanded && items && (
          <div className="h-full flex items-center relative">
            <div
              style={{ height: '80%', marginLeft: '33.5px' }}
              className='absolute border-l border-gray-600'></div>
            <div className='w-full ml-7'>
              {items.map((subItem: NavItem, subIndex: number) =>
                subItem.items ? navGroup(subItem, subIndex) : navItem(subItem, subIndex, identity)
              )}
            </div>
          </div>
        )
        }
      </div >
    );
  };


  return (
    <React.Fragment>
      <div>
        {items &&
          items.map((item: NavItem, index: number) => {
            if (item.component === NavSeparator) {
              if (item.roles && !item.roles.includes(identity?.role)) {
                return null;
              } else {
                return <NavSeparator key={index} text={item.name} />;

              }

            }
            return item.items ? navGroup(item, index) : navItem(item, index, identity);
          })}
      </div>
    </React.Fragment>
  );
};

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};
